import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const recruiterHomePage = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
            background: Color.Canvas,
            minHeight: "100vh",
            marginBottom: "-24.15vw",
            paddingBottom: "24.15vw"
        },
        leftWrapper: {
            position: "sticky",
            top: 0,
            zIndex: "3"
        },
        rightWrapper: {},
        searchWrapper: {
            display: "none"
        },
        searchBar: {
            display: "none"
        },
        profileWrapper: {
            display: "flex"
        },
        invoiceReminder: {
            color: Color.White,
            background: Color.LightOrange,
            padding: "0.1vw 0",
            cursor: "pointer",
            message: {
                fontSize: "3.38vw",
                justifySelf: "center"
            }
        },
        newJob: {
            display: "flex",
            alignItems: "center",
            fontSize: "3.86vw",
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            padding: "0",
            iconWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "8.21vw",
                width: "8.21vw",
                background: Color.DeepBlack,
                borderRadius: "4.10vw",
                marginLeft: "2.41vw"
            },
            icon: {
                height: "2.90vw",
                width: "2.90vw",
                fill: Color.White
            }
        },
        statusSection: {
            position: "sticky",
            top: "42.67vw",
            background: Color.Canvas,
            zIndex: "2"
        },
        header: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "4.83vw 4.83vw 2.41vw 4.83vw",
            titleGroup: {
                display: "flex",
                alignItems: "baseline",
                gap: "2.41vw"
            },
            title: {
                fontSize: "6.04vw",
                fontWeight: "700",
                color: Color.LightBlack,
                letterSpacing: "-0.02em"
            },
            postJob: {
                display: "none"
            },
            postJobIcon: {
                display: "none"
            }
        },
        tabs: {
            display: "flex",
            flexDirection: "row" as "row",
            padding: "0 4.83vw 4.83vw 4.83vw",
            overflowX: "scroll",
            overflowY: "hidden",
            gap: "1.21vw"
        },
        tab: {
            display: "flex",
            alignItems: "center",
            gap: "1.45vw",
            height: "8.45vw",
            lineHeight: "1",
            padding: "0 3.62vw",
            borderRadius: "6.04vw",
            fontSize: "3.62vw",
            fontWeight: "500",
            color: Color.SharpAsh,
            background: "transparent",
            cursor: "pointer",
            flex: "0 0 auto",
            whiteSpace: "nowrap" as "nowrap",
            count: {
                fontWeight: "600",
                fontSize: "3.38vw"
            },
            active: {
                background: Color.LightBlue,
                color: Color.Blue
            }
        },
        selectWrapper: {
            display: "flex",
            flexDirection: "column",
            margin: "0 4.83vw 3.73vw 4.83vw"
        },
        toolbarRow: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginTop: "3.62vw",
            flexWrap: "wrap" as "wrap",
            gap: "2.41vw"
        },
        sortSelect: {
            marginLeft: "unset",                
            marginTop: "unset",
            buttonWrapper: { 
                backgroundColor: Color.White,
                width: "40vw"
            },
            button: {
                marginTop: 0,
                width: "auto"
            },
            hover: {
                width: "40vw"
            }
        },
        filterButtonWrapper: {
            position: "relative"
        },
        filterButton: {
            display: "flex",
            alignItems: "center",
            height: "8.4vw",
            padding: "0 3.62vw",
            borderRadius: "2.41vw",
            border : `1px ${Color.LightSilver} solid`,
            background: Color.White,
            color: Color.SharpAsh,
            fontSize: "3.62vw",
            cursor: "pointer",
            gap: "1.21vw"
        },
        filterBadge: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "4.83vw",
            height: "4.83vw",
            borderRadius: "50%",
            background: Color.Blue,
            color: Color.White,
            fontSize: "2.90vw",
            fontWeight: "600",
            padding: "0",
            flexShrink: 0
        },
        filterPanel: {
            panel: {
                backgroundColor: Color.White,
                border: "1px solid " + Color.Ash,
                borderRadius: "2.41vw",
                padding: "3.62vw",
                boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 1px 3px rgba(16,24,40,0.06)",
                marginTop: "2.41vw",
                marginBottom: "2.41vw"
            },
            body: {
                gap: "3.62vw",
                padding: "0",
                overflowY: "visible" as "visible",
                flex: "unset"
            },
            section: {
                marginTop: "2.21vw",
                display: "flex",
                flexDirection: "column" as "column"
            },
            sectionTitle: {
                fontSize: "3.86vw",
                fontWeight: "600",
                color: Color.SharpAsh,
                marginBottom: "1.21vw"
            },
            orgSelect: {
                marginLeft: "unset",                
                marginTop: "1vw",
                buttonWrapper: { 
                    backgroundColor: Color.White
                },
                button: {
                    width: "auto"
                },
                hover: {
                    width: "80vw"
                }
            },
            sectorSelectWrapper: {
                position: "relative",
                marginTop: "2.41vw",
                display: "flex",
                height: "8.45vw",
                alignItems: "center",
                borderRadius: "2.41vw",
                border: "1px solid " + Color.LightSilver,
                color: Color.SharpAsh,
                fontSize: "3.62vw",
                title: {
                    marginLeft: "auto"
                }
            },
            buttonIcon: {
                width: "3.2vw",
                height: "3.2vw",
                fill: Color.SharpAsh,              
                marginLeft: "1.33vw",
                marginRight: "auto",
                transition: "transform .1s ease-in-out",
                hover: {
                    transform: "rotate(180deg)"
                }
            },
            sectorSelect: {         
                wrapper: {
                    display: "block",
                    position: "absolute",
                    top: "calc(100% + 1.21vw)",
                    left: "0",
                    width: "calc(100% - 5vw)",
                    backgroundColor: Color.White,
                    height: "auto",
                    maxHeight: "56.52vw",
                    WebkitOverflowScrolling: "touch",
                    padding: "0 2.41vw 1.35vh",
                    borderRadius: "1.35vh",
                    border: "1px solid " + Color.LightSilver,
                    zIndex: 1
                },
                search: {
                    display: "none",
                    icon: {
                        display: "none"
                    }
                },
                scrollArea: {
                    height: "95%",
                    overflow: "auto",
                    maxHeight: "56.52vw",
                    marginTop: "1.38vw"
                },
                option: {
                    margin: "0 1.38vw",
                    padding: "1.44vw 0.46vw",
                    cursor: "pointer",
                    position: "relative" as "relative",
                    display: "flex",
                    zIndex: 1,
                    overflow: "hidden",
                    hover: {
                        backgroundColor: Color.LightBlue,
                        margin: "0 1.38vw",
                        borderRadius: "1.69vw"
                    },
                    leave: {
                        backgroundColor: "unset"
                    }
                },
                checkbox: {
                    borderRadius: "0.5vw",
                    marginTop: "0.8vw",
                    zIndex: 0,
                    cursor: "pointer",
                    border: "0.07vw solid " + Color.SharpAsh,
                    height: "2.65vw",
                    width: "2.65vw",
                    float: "left",
                    marginLeft: "2.17vw"
                },
                checkMark: {
                    marginLeft: "2.25vw",
                    marginTop: "0.8vw",
                    height: "2.72vw",
                    width: "2.72vw",
                    float: "left"
                },
                optionLabel: {
                    cursor: "pointer",
                    marginLeft: "3.62vw",
                    fontSize: "3.86vw",
                    fontWeight: "500",
                    width: "70%",
                    color: Color.MiddleBlack
                },
                bottomBorder: {
                    border: 0,
                    height: "1px",
                    width: "92%",
                    background: Color.MiddleAsh,
                    margin: "0 auto",
                    zIndex: "1"
                },
                hoveredBorder: {
                    background: Color.White,
                    borderRadius: "1px"
                },
                closeButton: {
                    display: "none"
                }
            },
            jobTypeSelectWrapper: {
                position: "relative", 
                marginTop: "2.41vw",
                display: "flex",
                height: "8.45vw",
                alignItems: "center",
                borderRadius: "2.41vw",
                border: "1px solid " + Color.LightSilver,
                color: Color.SharpAsh,
                fontSize: "3.62vw"
            },
            jobTypeSelect: {
                wrapper: {
                    display: "block",
                    position: "absolute",
                    top: "calc(100% + 1.21vw)",
                    left: "0",
                    width: "75.5vw",
                    backgroundColor: Color.White,
                    height: "56.52vw",
                    WebkitOverflowScrolling: "touch",
                    padding: "0 2.41vw 1.35vh",
                    borderRadius: "1.35vh",
                    border: "1px solid " + Color.LightSilver,
                    zIndex: 1
                },
                scrollArea: {
                    height: "95%",
                    overflow: "auto",
                    marginTop: "1.38vw"
                },
                option: {
                    margin: "0 1.38vw",
                    padding: "1.44vw 0.46vw",
                    cursor: "pointer",
                    position: "relative" as "relative",
                    display: "flex",
                    zIndex: 1,
                    overflow: "hidden",
                    hover: {
                        backgroundColor: Color.LightBlue,
                        margin: "0 1.38vw",
                        borderRadius: "1.69vw"
                    },
                    leave: {
                        backgroundColor: "unset"
                    }
                },
                checkbox: {
                    borderRadius: "0.5vw",
                    marginTop: "0.8vw",
                    zIndex: 0,
                    cursor: "pointer",
                    border: "0.07vw solid " + Color.SharpAsh,
                    height: "2.65vw",
                    width: "2.65vw",
                    float: "left",
                    marginLeft: "2.17vw"
                },
                checkMark: {
                    marginLeft: "2.25vw",
                    marginTop: "0.8vw",
                    height: "2.72vw",
                    width: "2.72vw",
                    float: "left"
                },
                optionLabel: {
                    cursor: "pointer",
                    marginLeft: "3.62vw",
                    fontSize: "3.86vw",
                    fontWeight: "500",
                    width: "70%",
                    color: Color.MiddleBlack
                },
                bottomBorder: {
                    border: 0,
                    height: "1px",
                    width: "92%",
                    background: Color.MiddleAsh,
                    margin: "0 auto",
                    zIndex: "1"
                },
                hoveredBorder: {
                    background: Color.White,
                    borderRadius: "1px"
                }
            },
            typeSelect: {
                marginLeft: "unset",                
                marginTop: "1.21vw",
                button: {
                    width: "auto"
                },
                hover: {                
                    width: "80.5vw"
                }
            },
            footer: {
                display: "flex",
                justifyContent: "flex-end",
                gap: "1.21vw",
                padding: "2.41vw 0 0 0",
                marginTop: "2.41vw"
            },
            clearButton: {
                flex: "unset",
                height: "auto",
                border: "none",
                background: "none",
                color: Color.SharpAsh,
                fontSize: "4.38vw",
                fontWeight: "500",
                padding: "1.21vw 1.93vw",
                borderRadius: "1.21vw",
                cursor: "pointer"
            }
        },
        bulkActionBar: {
            display: "flex",
            flexDirection: "row" as "row",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2.41vw",
            padding: "2.41vw 3.86vw",
            background: "#0C1B2E",
            borderRadius: "2.41vw",
            marginTop: "2.41vw",
            marginBottom: "2.41vw",
            selected: {
                fontSize: "3.38vw",
                color: Color.White,
                fontWeight: "500"
            },
            actions: {
                display: "flex",
                gap: "1.45vw"
            },
            exportButton: {
                display: "inline-flex",
                alignItems: "center",
                gap: "1.21vw",
                height: "7.73vw",
                padding: "0 2.90vw",
                background: "rgba(255,255,255,0.12)",
                color: Color.White,
                border: "none",
                borderRadius: "1.45vw",
                fontSize: "3.14vw",
                fontWeight: "500"
            },
            archiveButton: {
                display: "inline-flex",
                alignItems: "center",
                gap: "1.21vw",
                height: "7.73vw",
                padding: "0 2.90vw",
                background: "rgba(255,255,255,0.12)",
                color: Color.White,
                border: "none",
                borderRadius: "1.45vw",
                fontSize: "3.14vw",
                fontWeight: "500"
            },
            clearButton: {
                display: "inline-flex",
                alignItems: "center",
                gap: "1.21vw",
                height: "7.73vw",
                padding: "0 2.90vw",
                background: "rgba(255,255,255,0.12)",
                color: Color.White,
                border: "none",
                borderRadius: "1.45vw",
                fontSize: "3.14vw",
                fontWeight: "500"
            },
            buttonIcon: {
                width: "3.38vw",
                height: "3.38vw",
                overflow: "visible",
                fill: "currentColor",
                flexShrink: 0
            }
        },
        perPageSelect: {
            marginLeft: "unset",
            marginTop: "unset",
            buttonWrapper: { 
                backgroundColor: Color.White,
                width: "13.58vw"
            },
            button: {
                width: "auto"
            },
            hover: {
                width: "13.58vw"
            }
        },
        buttonIcon: {
            width: "3.2vw",
            height: "3.2vw",
            fill: Color.SharpAsh,              
            marginLeft: "1.33vw",
            marginRight: "auto",
            transition: "transform .1s ease-in-out",
            hover: {
                transform: "rotate(180deg)"
            }
        },
        filterIcon: {
            width: "3.2vw",
            height: "3.2vw",
            fill: Color.SharpAsh
        },
        downloadExcel: {
            wrapper: {
                margin: "6.04vw 0 0 auto"
            },
            button: {
                display: "inline-flex",
                alignItems: "center",
                gap: "1.93vw",
                height: "9.66vw",
                padding: "0 3.62vw",
                border: "1px solid " + Color.Ash,
                borderRadius: "2.41vw",
                background: Color.White,
                fontSize: "3.62vw",
                fontWeight: "500",
                color: Color.SharpAsh,
                cursor: "pointer",
                marginBottom: "1.45vw"
            },
            icon: {
                width: "3.62vw",
                height: "3.62vw",
                fill: Color.SharpAsh,
                flexShrink: 0
            },
            box: {
                display: "none",
                width: "54.36vw",
                height: "40.72vw",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.41vw",
                padding: "2.21vw",
                background: Color.White,
                open: {
                    display: "block",
                    position: "absolute",
                    right: "4.83vw",
                    zIndex: 1
                }
            },
            row: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "1.69vw",
                fontSize: "3.38vw",
                color: Color.DeepAsh
            },
            dateInput: {
                width: "37.03vw",
                height: "13.04vw",
                fontSize: "3.38vw",
                padding: "0 2.41vw",
                border: "none",
                borderRadius: "2.41vw",
                color: Color.SharpAsh,
                backgroundColor: Color.LightAsh,
                marginLeft: "auto"               
            },
            downloadButton: {
                width: "100%",
                height: "7.73vw",
                border: "none",
                borderRadius: "2.41vw",
                fontSize: "3.38vw",
                background: Color.Blue,
                color: Color.White,
                alignItems: "center",
                justifyContent: "center",
                marginTop: "1.93vw"
            }
        },
        vacancyList: {
            minWidth: 0,
            margin: "0 4.83vw",
            background: Color.White,
            border: "1px solid #E8EBEF",
            borderRadius: "2.90vw",
            boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 1px 3px rgba(16,24,40,0.06)",
            noVacancies: {
                background: "transparent",
                border: "none",
                boxShadow: "none"
            }
        },
        paginationWrapper: {
            display: "flex",
            alignItems: "center",
            margin: "3.62vw 4.83vw 0 4.83vw"
        },
        vacancyCard: {
            display: "flex",
            flexDirection: "column" as "column",
            overflow: "hidden",                         
            padding: "3.86vw 4.35vw",
            position: "relative" as "relative",
            transition: "background 0.12s",
            checked: {
                background: "#E7F4FB"
            },
            firstItem: {
                borderTopLeftRadius: "2.90vw",
                borderTopRightRadius: "2.90vw"
            },
            lastItem: {
                borderBottomLeftRadius: "2.90vw",
                borderBottomRightRadius: "2.90vw"
            },
            titleRow: {
                display: "flex",
                flexDirection: "row" as "row",                
                alignItems: "flex-start"
            },
            option: {
                padding: "0.48vw 2.17vw 0 0",
                cursor: "pointer",
                display: "flex",
                flexShrink: 0
            },
            checkbox: {
                borderRadius: "0.97vw",
                cursor: "pointer",
                border: "0.24vw solid " + Color.SharpAsh,
                height: "4.11vw",
                width: "4.11vw"
            },
            checkMark: {
                height: "4.11vw",
                width: "4.11vw",
                border: "0.24vw solid " + Color.Blue,
                borderRadius: "0.97vw"
            },
            rowMain: {
                flex: "1",                
                overflow: "hidden"
            },
            titleLine: {
                display: "flex",
                minWidth: 0,
                width: "100%",
                overflow: "hidden",
                alignItems: "center",
                flexWrap: "nowrap" as "nowrap",
                gap: "1.93vw"                
            },
            titleContainer: {
                overflow: 'hidden',
                whiteSpace: 'nowrap'
            },
            title: {
                fontSize: "3.86vw",
                fontWeight: "600",
                color: "#1A2130",                        
                maxWidth: '58vw',
                slider: {
                    animation: "scrollText 20s linear infinite"
                }
            },
            tagOpt: {
                fontSize: "2.78vw",
                fontWeight: "500",
                color: "#0F6E56",
                background: "#E1F5EE",
                padding: "0.48vw 1.93vw",
                borderRadius: "1.21vw",
                whiteSpace: "nowrap" as "nowrap"
            },
            urgentTag: {
                fontSize: "2.78vw",
                fontWeight: "500",
                color: Color.Red
            },
            promoteAd: {
                backgroundColor: Color.White,
                color: Color.Blue,
                border: "0.5px solid" + Color.Blue,
                marginLeft: "2vw",
                fontSize: "2.78vw",
                padding: "0.48vw 1.93vw",
                borderRadius: '6.04vw',
                fontWeight: "500",
                hovered: {
                    border: "2px solid" + Color.Blue
                }
            },
            bumpUp: {
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center",
                width: "4.35vw",
                height: "4.35vw",
                borderRadius: "50%",
                backgroundColor: Color.LightRed,
                flexShrink: 0
            },
            bumpUpIcon: {
                width: "50%"
            },
            rowMeta: {
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap" as "wrap",
                gap: "1.21vw",
                fontSize: "3.14vw",
                color: "#5A6472",
                marginTop: "0.96vw"
            },
            location: {
                height: "4.11vw",
                width: "4.11vw"
            },
            rowRight: {
                marginTop: "2.41vw"
            },
            applicants: {
                fontSize: "3.38vw",
                color: "#1A2130",
                fontWeight: "500"
            },
            newBadge: {
                color: "#E24B4A",
                fontWeight: "600"
            },
            rowStatus: {
                fontSize: "2.90vw",
                color: "#8A93A1",
                marginTop: "0.72vw"
            },
            downloadCvLess: {
                width: "3.84vw",
                height: "3.30vw",
                marginLeft: "2.06vw"
            },
            buttons: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "3.38vw"
            },
            buttonWrapper: {
                display: "flex"
            },
            button: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "12.08vw",
                height: "7.25vw",
                borderRadius: "1.69vw",
                marginRight: "1.93vw",
                wider: {
                    width: "28.98vw"
                }
            },
            edit: {
                background: Color.DeepBlack
            },
            duplicate: {
                background: Color.LightBlue
            },
            view: {
                background: Color.Cultured
            },
            editIcon: {
                width: "3.95vw",
                height: "3.51vw",
                fill: Color.White
            },
            duplicateIcon: {
                width: "3.08vw",
                height: "3.52vw",
                fill: Color.Blue
            },
            viewIcon: {
                width: "4.20vw",
                height: "3.77vw",
                fill: Color.SharpAsh
            },
            archiveButton: {
                width: "28.98vw",
                height: "7.25vw",
                background: Color.Linen,
                color: Color.Red,
                borderRadius: "1.69vw",
                fontSize: "3.86vw",
                fontWeight: "bold"
            },
            bottomBorder: {
                borderBottom: "1px solid #F1F3F6"
            },
            menuBtn: {
                display: "none"
            },
            menu: {},
            menuItem: {},
            menuItemDanger: {},
            menuSep: {},
            menuIcon: {}
        },
        pagination: {
            nextButton: {
                width: "7.25vw",
                height: "7.25vw",
                backgroundColor: Color.DeepBlack,
                border: "none"
            },
            button: {
                color: Color.LightBlack,
                active: {
                    backgroundColor: Color.SharpAsh
                }
            }
        },
        verifyDialog: {
            position: "fixed" as "fixed",
            left: "0",
            right: "0",
            bottom: "0",
            top: "0",
            transition: "transform 0.3s ease-out",
            zIndex: "2",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: {
                position: "absolute" as "absolute",
                left: "0",
                right: "0",
                bottom: "0",
                top: "0",
                backgroundColor: Color.Black,
                opacity: 0.4
            },
            container: {
                position: "relative",
                backgroundColor: Color.White,
                borderRadius: "2.41vw",
                padding: "2.41vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "73.50%",
                height: "21.40%"
            },
            close: {
                position: "absolute" as "absolute",
                width: "6.28vw",
                height: "6.28vw",
                top: "2vw",
                right: "3vw",
                cursor: "pointer",
                zIndex: "3"
            },
            text: {
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "4vw",
                lineHeight: "1.5",
                width: "83%"   
            }
        },
        warningDialog: {
            touchAction: "none",
            container: {
                width: "calc(100% - 9.66vw)",
                height: "unset",
                padding: "7.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            closeButton: {
                top: "2.42vw",
                overflow: "visible"
            }
        },
        dialog: {
            title: {
                marginTop: "unset",
                marginBottom: "7vw",
                fontSize: "7.24vw",
                color: Color.LightBlack
            },  
            icon : {
                position: "absolute" as "absolute",
                width: "5vw",
                height: "5vw",
                top: "12.2vw",
                left: "6.5vw"
            },        
            message: {
                margin: "4.83vw 0 0 0",
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                font: Font.Default,
                fontWeight: "600"
            },
            button: {
                width: "50%",
                height: "12.07vw",
                fontWeight: "bold",
                fontSize: "4.83vw",
                borderRadius: "2.41vw",
                margin: "7.24vw 0 0 0",
                blue: {
                    border: "3px solid " + Color.Blue,
                    color: Color.Blue,
                    background: "transparent",
                    marginRight: "2.89vw"
                },
                red: {
                    border: "none",
                    color: Color.Red,
                    backgroundColor: Color.LightRed
                }
            }
        },
        noVacancies: {
            wrapper: {
                borderRadius: "2.77vw",
                border: "1px solid " + Color.HarvestGold,
                backgroundColor: Color.LightGold,
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center" as "center",
                padding: "2.41vh",
                color: Color.HarvestGold,
                fontSize: "4.5vw",
                fontFamily: Font.Poppins,
                margin: "21.73vw auto 0 auto",
                textAlign: "center"
            },
            icon: {
                marginRight: "1.43vw",
                width: "8.33vw",
                height: "8.33vw",
                marginLeft: "1vw"
            }
        },
        invoiceDialog: {
            position: "fixed" as "fixed",
            left: "0",
            right: "0",
            bottom: "0",
            top: "0",
            transition: "transform 0.3s ease-out",
            zIndex: "2",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            container: {
                position: "relative",
                backgroundColor: Color.White,
                borderRadius: "2.41vw",
                padding: "2.41vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "73.50%",
                height: "47vw"
            },
            icon : {
                position: "absolute" as "absolute",
                width: "12vw",
                height: "12vw",
                top: "9.2vw",
                left: "33.5vw"
            },
            content: {
                margin: "10.83vw 0 0 0"
            },     
            message: {
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                font: Font.Default,
                fontWeight: "700",
                width: "33vw",
                textAlign: "center"
            },
            buttons: {
                justifyContent: "center"
            },
            button: {
                width: "100%",
                height: "12.07vw",
                fontWeight: "bold",
                fontSize: "3.86vw",
                borderRadius: "2.41vw",
                color: Color.White,
                backgroundColor: Color.Green
            }
        },
        quotaDialog: {
            title: {
                textAlign: "center" as "center",
                marginBottom: "4.83vw",
                fontSize: "4.83vw",
                color: Color.LightBlack,
                fontWeight: "600"
            },
            alertWrapper: {
                margin: "0 auto",
                textAlign: "center" as "center",
                paddingBottom: "4.83vw"
            },
            expiredBadge: {
                display: "inline-block",
                paddingLeft: "1.21vw",
                paddingRight: "1.21vw",
                width: "65vw",
                textAlign: "center" as "center",
                fontSize: "3.86vw",
                fontWeight: "600",
                color: Color.Red,
                border: "2px solid " + Color.Red,
                borderRadius: "1.21vw",
                padding: "2.41vw 1.21vw",
                backgroundColor: Color.Linen
            },
            table: {
                margin: "0 auto",
                marginBottom: "4.83vw",
                border: "2px solid " + Color.Red,
                borderRadius: "4.83vw"
            },
            tableCell: {
                padding: "1.21vw 2.41vw",
                textAlign: "left" as "left"
            },
            invalidLabel: {
                paddingLeft: "0.72vw",
                fontSize: "3.38vw",
                color: Color.MiddleBlack,
                fontWeight: "600"
            },
            invalidValue: {
                fontSize: "3.38vw",
                color: Color.DeepBlack,
                fontWeight: "bold",
                backgroundColor: Color.LightAsh,
                padding: "1.21vw 2.41vw",
                borderRadius: "1.21vw"
            },
            buttonWrapper: {
                margin: "0 auto",
                textAlign: "center" as "center"
            },
            purchaseButton: {
                padding: "0 2.21vw",
                width: "auto",
                height: "9.66vw",
                backgroundColor: Color.Green,
                borderColor: Color.Green,
                color: Color.White,
                textAlign: "center" as "center",
                cursor: "pointer",
                fontSize: "3.86vw",
                fontWeight: "bold",
                borderRadius: "1.21vw",
                border: "none"
            },
            topUpButton: {
                paddingLeft: "1.21vw",
                paddingRight: "1.21vw",
                width: "36.23vw",
                height: "9.66vw",
                backgroundColor: Color.Green,
                borderColor: Color.Green,
                color: Color.White,
                textAlign: "center" as "center",
                cursor: "pointer",
                fontSize: "3.86vw",
                fontWeight: "bold",
                borderRadius: "1.21vw",
                border: "none"
            }
        }
    },
    desktop: {
        mainWrapper: {
            flexDirection: "row" as "row",
            padding: "1.56vw 1.56vw 7.8vw 1.56vw",
            marginBottom: "-7.8vw",
            hidePaddingTop: {
                paddingTop: "0"
            }
        },        
        leftWrapper: {
            position: "relative"
        },
        rightWrapper: {
            width: "77.5%",
            paddingLeft: "2.32vw"
        },
        profileWrapper: {
            marginLeft: "auto"
        },
        invoiceReminder: {
            padding: "0.3vw 0",
            message: {
                fontSize: "1.04vw"
            }
        },
        newJob: {
            display: "none"
        },
        statusSection: {
            display: "flex",
            flexWrap: "wrap" as "wrap",
            position: "static",
            background: "transparent",
            marginBottom: "0.93vw"
        },
        header: {
            display: "contents",
            padding: "0.52vw 0.42vw 0.83vw 0.42vw",
            titleGroup: {
                gap: "0.78vw"
            },
            title: {
                fontSize: "1.82vw"
            },
            postJob: {
                order: 3,
                display: "inline-flex",
                background: Color.DeepBlack,
                color: Color.White,
                fontWeight: "600",
                padding: "0 1.25vw",
                height: "2.60vw",
                width: "auto",
                borderRadius: "0.52vw",
                marginLeft: "auto",
                fontSize: "0.94vw",
                gap: "0.52vw",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                cursor: "pointer"
            },
            postJobIcon: {
                display: "block",
                height: "0.83vw",
                width: "0.83vw",
                fill: Color.White
            }
        },
        tabs: {
            display: "flex",
            order: 2,
            gap: "0.26vw",
            alignSelf: "center",
            padding: "0 0.42vw",
            overflowX: "unset",
            overflowY: "unset"
        },
        tab: {
            height: "2.08vw",
            padding: "0 0.94vw",
            borderRadius: "1.30vw",
            fontSize: "0.88vw",
            gap: "0.42vw",
            count: {
                fontSize: "0.88vw"
            }
        },
        selectWrapper: {
            margin: "0 0 0.97vw 0.42vw"
        },
        toolbarRow: {
            marginTop: "0",
            gap: "0.52vw",
            alignItems: "unset",
            flexWrap: "nowrap" as "nowrap"
        },
        sortSelect: {
            buttonWrapper: { 
                width: "11vw"
            },
            button: {
                height: "1.82vw"
            },
            hover: {
                width: "11vw"
            }
        },
        filterButton: {
            height: "1.84vw",
            padding: "0 0.83vw",
            borderRadius: "0.52vw",
            fontSize: "0.937vw",
            gap: "0.42vw"
        },
        filterBadge: {
            width: "1.18vw",
            height: "1.18vw",
            fontSize: "0.76vw"
        },
        filterPanel: {
            panel: {
                borderRadius: "0.83vw",
                padding: "1.11vw",
                marginTop: "0",
                marginBottom: "0.97vw"
            },
            body: {
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(17vw, 1fr))",
                gap: "0.97vw"
            },
            section: {
                marginTop: "0.42vw"
            },
            sectionTitle: {
                fontSize: "0.83vw",
                marginLeft: "0.52vw",
                marginBottom: "0.42vw"
            },
            orgSelect: {
                marginTop: "unset",
                buttonWrapper: { 
                    width: "16.38vw"
                },
                button: {
                    height: "1.82vw",
                    marginLeft: "0.52vw"
                },
                hover: {
                    width: "16.38vw"
                }
            },
            sectorSelectWrapper: {
                marginTop: 0,
                height: "1.82vw",
                borderRadius: "0.52vw",
                fontSize: "0.94vw",
                paddingLeft: "1.11vw",
                paddingRight: "1.11vw",
                marginLeft: "0.52vw",
                title: {
                    marginLeft: "auto"
                }
            },
            buttonIcon: {
                width: "0.8vw",
                height: "0.8vw",
                marginLeft: "0.36vw",
                marginRight: "auto"
            },
            sectorSelect: {
                wrapper: {
                    width: "stretch",
                    maxHeight: "15.15vw",
                    padding: "0.52vw",
                    borderRadius: "0.52vw",
                    top: "calc(100%)"
                },
                scrollArea: {
                    marginTop: "0.36vw",
                    maxHeight: "15.15vw"
                },
                option: {
                    margin: "0",
                    padding: "0.36vw",
                    hover: {
                        margin: "0",
                        borderRadius: "0.364vw"
                    }
                },
                optionLabel: {
                    fontSize: "0.83vw",
                    marginLeft: "0.51vw"
                },
                checkbox: {
                    marginLeft: "0.46vw",
                    borderRadius: "0.1vw",
                    marginTop: "0.2vw",
                    height: "0.57vw",
                    width: "0.57vw"
                },
                checkMark: {
                    marginLeft: "0.46vw",
                    marginTop: "0.2vw",
                    height: "0.7vw",
                    width: "0.7vw"
                }
            },
            jobTypeSelectWrapper: {
                marginTop: 0,
                height: "1.82vw",
                borderRadius: "0.52vw",
                fontSize: "0.94vw",
                paddingLeft: "2.11vw",
                paddingRight: "2.11vw",
                marginLeft: "0.52vw"
            },
            jobTypeSelect: {
                wrapper: {
                    width: "stretch",
                    height: "15.15vw",
                    padding: "0.52vw",
                    borderRadius: "0.52vw",
                    top: "calc(100%)"
                },
                scrollArea: {
                    marginTop: "0.36vw"
                },
                option: {
                    margin: "0",
                    padding: "0.36vw",
                    hover: {
                        margin: "0",
                        borderRadius: "0.364vw"
                    }
                },
                checkbox: {
                    marginLeft: "0.46vw",
                    borderRadius: "0.1vw",
                    marginTop: "0.2vw",
                    height: "0.57vw",
                    width: "0.57vw"
                },
                checkMark: {
                    marginLeft: "0.46vw",
                    marginTop: "0.2vw",
                    height: "0.7vw",
                    width: "0.7vw"
                },
                optionLabel: {
                    fontSize: "0.83vw",
                    marginLeft: "0.51vw"
                }
            },
            typeSelect: {
                marginTop: "unset",
                button: {
                    height: "1.82vw",
                    marginLeft: "0.52vw",
                    width: "100%"
                },
                hover: {                
                    width: "16.58vw"
                }
            },
            footer: {
                gap: "0.55vw",
                padding: "0.97vw 0 0 0",
                marginTop: "0.97vw"
            },
            clearButton: {
                fontSize: "1.04vw",
                padding: "0.42vw 0.69vw",
                borderRadius: "0.42vw"
            }
        },
        bulkActionBar: {
            padding: "0.69vw 1.11vw",
            borderRadius: "0.69vw",
            marginTop: "0.69vw",
            marginBottom: "0.83vw",
            selected: {
                fontSize: "0.94vw"
            },
            actions: {
                gap: "0.42vw"
            },
            exportButton: {
                gap: "0.42vw",
                height: "2.22vw",
                padding: "0 0.83vw",
                borderRadius: "0.42vw",
                fontSize: "0.90vw"
            },
            archiveButton: {
                gap: "0.42vw",
                height: "2.22vw",
                padding: "0 0.83vw",
                borderRadius: "0.42vw",
                fontSize: "0.90vw"
            },
            clearButton: {
                gap: "0.42vw",
                height: "2.22vw",
                padding: "0 0.83vw",
                borderRadius: "0.42vw",
                fontSize: "0.90vw"
            },
            buttonIcon: {
                width: "0.97vw",
                height: "0.97vw"
            }
        },
        perPageSelect: {
            marginBottom: "unset",
            buttonWrapper: { 
                width: "4.06vw"
            },
            button: {
                height: "1.82vw",
                marginLeft: "1.04vw"
            },
            hover: {
                width: "4.06vw"
            }
        },
        buttonIcon: {
            width: "0.8vw",
            height: "0.8vw",
            marginLeft: "0.36vw"
        },
        filterIcon: {
            width: "0.8vw",
            height: "0.8vw"
        },
        downloadExcel: {
            wrapper: {                
                margin: "0 0 0 auto"
            },
            button: {
                gap: "0.52vw",
                height: "2.34vw",
                padding: "0 0.83vw",
                borderRadius: "0.52vw",
                fontSize: "0.88vw",
                marginBottom: "0.34vw"
            },
            icon: {
                width: "0.94vw",
                height: "0.94vw"
            },
            box: {
                width: "14.30vw",
                height: "9.22vw",
                borderRadius: "0.52vw",
                padding: "0.83vw",
                open: {
                    right: "1.56vw"
                }
            },
            row: {
                marginBottom: "0.52vw",
                fontSize: "0.83vw",
                fontFamily: Font.Poppins
            },
            dateInput: {
                width: "9vw",
                height: "2.96vw",
                fontSize: "0.83vw",
                padding: "0 1.07vw",
                borderRadius: "0.52vw",
                fontFamily: Font.Poppins
            },
            downloadButton: {
                height: "1.82vw",
                borderRadius: "0.52vw",
                fontSize: "0.94vw",
                marginTop: "0.26vw"
            }
        },
        vacancyList: {
            margin: "unset",
            borderRadius: "0.83vw"
        },
        vacancyCard: {
            flexDirection: "row" as "row",
            padding: "0.97vw 1.11vw",
            alignItems: "center",
            gap: "0.97vw",
            cursor: "pointer",
            overflow: "visible",
            firstItem: {
                borderTopLeftRadius: "0.83vw",
                borderTopRightRadius: "0.83vw"
            },
            lastItem: {
                borderBottomLeftRadius: "0.83vw",
                borderBottomRightRadius: "0.83vw"
            },
            titleRow: {
                alignItems: "center",
                flex: "1",
                minWidth: "0"
            },
            option: {
                padding: "0 0.66vw 0 0"
            },
            checkbox: {
                borderRadius: "0.20vw",
                border: "0.06vw solid " + Color.SharpAsh,
                height: "0.83vw",
                width: "0.83vw",
                marginTop: "0"
            },
            checkMark: {
                height: "0.83vw",
                width: "0.83vw",
                marginTop: "0",
                marginRight: "0",
                borderRadius: "0.20vw",
                border: "0.06vw solid " + Color.Blue
            },
            rowMain: {
                marginLeft: "1vw"
            },
            titleLine: {
                gap: "0.42vw"
            },
            location: {
                height: "0.83vw",
                width: "0.83vw"
            },
            title: {
                maxWidth: '24vw',
                fontSize: "1.01vw"
            },
            tagOpt: {
                fontSize: "0.80vw",
                padding: "0.14vw 0.55vw",
                borderRadius: "0.35vw"
            },
            urgentTag: {
                fontSize: "0.80vw"
            },
            promoteAd: {
                fontSize: "0.78vw",
                marginLeft: "unset",
                padding: "0 0.55vw",
                borderRadius: '1.30vw'
            },
            bumpUp: {
                width: "1.18vw",
                height: "1.18vw"
            },
            rowMeta: {
                fontSize: "0.87vw",
                marginTop: "0.21vw",
                gap: "0.35vw"
            },
            rowRight: {
                textAlign: "right" as "right",
                flexShrink: 0,
                width: "16vw",
                marginTop: "0"
            },
            applicants: {
                fontSize: "0.94vw",
                fontWeight: "normal"
            },
            rowStatus: {
                fontSize: "0.80vw",
                marginTop: "0.41vw"
            },
            downloadCvLess: {
                display: "none"
            },
            buttons: {
                display: "none"
            },
            hovered: {
                background: "#FBFCFD"
            },
            menuBtn: {
                display: "flex",
                border: "none",
                background: "transparent",
                width: "2.08vw",
                height: "2.08vw",
                borderRadius: "0.42vw",
                cursor: "pointer",
                color: "#8A93A1",
                alignItems: "center",
                justifyContent: "center"
            },
            menu: {
                display: "block",
                position: "absolute" as "absolute",
                right: "0.97vw",
                top: "3.19vw",
                background: Color.White,
                border: "1px solid #E8EBEF",
                borderRadius: "0.69vw",
                boxShadow: "0 0.42vw 1.67vw rgba(16,24,40,0.12), 0 0.14vw 0.42vw rgba(16,24,40,0.08)",
                padding: "0.42vw",
                minWidth: "11.67vw",
                zIndex: 20
            },
            menuItem: {
                display: "flex",
                alignItems: "center",
                gap: "0.69vw",
                width: "100%",
                border: "none",
                background: "none",
                padding: "0.55vw 0.69vw",
                borderRadius: "0.42vw",
                fontSize: "0.94vw",
                color: Color.LightBlack,
                cursor: "pointer",
                textAlign: "left" as "left"
            },
            menuItemDanger: {
                display: "flex",
                alignItems: "center",
                gap: "0.69vw",
                width: "100%",
                border: "none",
                background: "none",
                padding: "0.55vw 0.69vw",
                borderRadius: "0.42vw",
                fontSize: "0.94vw",
                color: "#E24B4A",
                cursor: "pointer",
                textAlign: "left" as "left"
            },
            menuSep: {
                height: "1px",
                background: "#F1F3F6",
                margin: "0.35vw 0"
            },
            menuIcon: {
                width: "1.04vw",
                height: "1.04vw",
                flexShrink: 0
            }
        },
        paginationWrapper: {
            margin: "2.10vw 0 0 0"
        },
        pagination: {
            margin: "unset",
            marginLeft: "auto",
            nextButton: {
                width: "2.60vw",
                height: "2.60vw"
            }
        },
        verifyDialog: {
            container: {
                borderRadius: "0.52vw",
                height: "19.20%",
                width: "50.50%",
                padding: "1vw 3vw"
            },
            close: {
                borderRadius: "50%",
                width: "1.8vw",
                height: "1.8vw",
                top: "0.73vw",
                right: "0.73vw"
            },
            text: {
                fontSize: "1.10vw",
                lineHeight: "1.5vw",
                width: "85%"
            }
        },
        warningDialog: {
            container: {
                width: "21.33vw",                
                padding: "2.5vw 3.54vw",
                borderRadius: "0.52vw"
            },
            closeButton: {
                top: "0.73vw"
            }
        },
        dialog: {
            title: {
                fontSize: "1.56vw",
                marginBottom: "1.51vw"
            },
            icon : {
                width: "1.3vw",
                height: "1.3vw",
                top: "4.29vw",
                left: "3.5vw"
            },
            message: {
                margin: "1.51vw 0 0 0",
                fontSize: "1.2vw",
                lineHeight: "1.5"
            },
            button: {
                width: "10.15vw",
                height: "2.604vw",
                fontSize: "1.041vw",
                borderRadius: "0.52vw",
                margin: "1.25vw 0 0 0",
                blue: {
                    marginRight: "0.625vw"
                },
                red: {
                    backgroundColor: Color.Linen
                }
            }
        },
        noVacancies: {
            wrapper: {
                width: "75%",
                borderRadius: "0.52vw",
                margin: "10vh auto 0 auto",
                padding: "1.56vw 0 1.56vw 0",
                fontSize: "1.137vw"
            },
            icon: {
                marginRight: "1.02vw",
                width: "1.58vw",
                height: "1.58vw"
            }
        },
        searchWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            marginBottom: "1.45vw",
            height: "4.68vw"
        },
        searchBar: {
            display: "flex",
            alignItems: "center",
            position: "relative",
            backgroundColor: Color.White,
            border: "1px solid " + Color.Ash,
            marginTop: "0.52vw",
            marginBottom: "1.56vw",
            width: "25.21vw",
            borderRadius: "0.52vw",
            height: "2.6vw",
            transition: "border-color .15s, box-shadow .15s",
            focused: {
                borderColor: Color.Blue,
                boxShadow: "0 0 0 3px #EBFAFF"
            },
            input: {
                border: "none",
                outline: "none",
                backgroundColor: Color.White,
                width: "100%",
                paddingLeft: "2.34vw",
                paddingRight: "0.52vw",
                fontSize: "0.94vw",
                color: Color.LightBlack
            },
            icon: {
                position: "absolute" as "absolute",
                fill: Color.SharpAsh,
                width: "1.04vw",
                height: "1.04vw",
                left: "0.78vw",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                flexShrink: 0
            }
        },
        invoiceDialog: {
            container: {
                borderRadius: "0.52vw",
                height: "20.20%",
                width: "23.50%",
                padding: "1vw 3vw"
            },
            close: {
                width: "1.8vw",
                height: "1.8vw",
                top: "0.73vw",
                right: "0.73vw"
            },
            icon: {
                width: "3vw",
                height: "3vw",
                top: "1.2vw",
                left: "13.5vw"
            },
            content: {
                margin: "3vw 0 0"
            },     
            message: {
                fontSize: "1.04vw",
                width: "18vw"
            },
            buttons: {
                display: "flex"
            },
            button: {
                width: "50%",
                height: "2.07vw",
                fontSize: "0.83vw",
                borderRadius: "0.52vw"
            }
        },
        quotaDialog: {
            title: {
                marginBottom: "1.04vw",
                fontSize: "1.25vw"
            },
            alertWrapper: {
                paddingBottom: "1.04vw"
            },
            expiredBadge: {
                paddingLeft: "0.26vw",
                paddingRight: "0.26vw",
                fontSize: "1.04vw",
                borderRadius: "0.26vw",
                width: "18vw",
                padding: "0.52vw 0.26vw"
            },
            table: {
                marginBottom: "1.04vw",
                borderRadius: "1.21vw"
            },
            tableCell: {
                padding: "0.26vw 0.52vw"
            },
            invalidLabel: {
                paddingLeft: "0.16vw",
                fontSize: "0.94vw"
            },
            invalidValue: {
                fontSize: "0.94vw",
                padding: "0.26vw 0.52vw",
                borderRadius: "0.26vw"
            },
            purchaseButton: {
                padding: "0 1.21vw",
                height: "2.08vw",
                fontSize: "0.94vw",
                borderRadius: "0.26vw"
            },
            topUpButton: {
                paddingLeft: "0.26vw",
                paddingRight: "0.26vw",
                width: "7.81vw",
                height: "2.08vw",
                fontSize: "0.94vw",
                borderRadius: "0.26vw"
            }
        }
    }
}